const TermsOfService = () => {
    return (
        <div>
            <h4>
                <strong>
                    TERMOS DE SERVIÇO E EULA(ACORDO DE LICENÇA DE USUÁRIO FINAL)
                </strong>
            </h4>
            <p>
                <strong>
                    Última revisão: 24 de outubro de 2024
                    <br />
                    Data de vigência: 24 de outubro de 2024
                </strong>
            </p>
            <p></p>
            <p>
                Estes Termos de Serviço e Acordo de Licença de Usuário Final
                (doravante “Termos”) constituem um contrato entre você e a parte
                contratante (doravante “NETDOOR”). Estes Termos regem o seu
                acesso e uso dos sites (
                <a href='http://www.plyosgames.com'>www.plyosgames.com</a> e
                sites associados), jogos, aplicativos móveis e outros produtos e
                serviços interativos que operamos (doravante “Serviços”).
            </p>
            <p>
                Por favor, revise cuidadosamente estes Termos antes de usar os
                Serviços. Reservamo-nos o direito, a nosso exclusivo critério e
                em conformidade com as leis aplicáveis, de modificar,
                descontinuar ou encerrar qualquer recurso dos Serviços a
                qualquer momento. Notificaremos você sobre quaisquer alterações
                aos Termos (incluindo a publicação dos Termos atualizados dentro
                dos Serviços). Ao continuar a usar os Serviços, você aceita
                quaisquer alterações nos Termos que se aplicam no momento em que
                são publicadas ou conforme exigido pela legislação aplicável.
            </p>
            <p>
                Observe que estes Termos incluem cláusulas de arbitragem
                vinculativa e renúncia de ação coletiva que podem afetar seus
                direitos de resolver disputas conosco. Você concorda em aceitar
                estes Termos eletronicamente e consente em armazenar registros
                relacionados a estes Termos em formato eletrônico.
            </p>

            <p>
                <strong>Licença Limitada</strong>
            </p>

            <p>
                Sob estes Termos, você recebe acesso e uso dos Serviços em um
                sistema operacional projetado para uso pessoal, não comercial e
                recreativo. Os Serviços são licenciados para você em uma base
                limitada, revogável, não sublicenciável, não transferível e não
                exclusiva, e não são vendidos para você.&nbsp;
            </p>

            <p>
                Você não pode modificar, copiar (exceto para uma única cópia de
                backup e cópias temporárias necessárias para a operação),
                distribuir, transmitir, exibir, executar, reproduzir, publicar,
                criar obras derivadas, adaptar, vender, alugar, sublicenciar ou
                de outra forma transferir ou disponibilizar os Serviços ou
                qualquer parte deles.&nbsp;
            </p>

            <p>
                Especificamente, você concorda em não vender ou transferir itens
                virtuais, moeda, pontos ou outro conteúdo dos Serviços em sites
                de leilão de terceiros (por exemplo, eBay ou IGE), sites de
                hacking, servidores privados, sites de “gold farming” ou outros
                serviços de terceiros, nem trocá-los por qualquer coisa de valor
                (seja dinheiro real ou outro). Você não tem direitos sobre os
                Serviços, exceto aqueles expressamente concedidos por estes
                Termos. Se você violar qualquer disposição destes Termos, sua
                licença será automaticamente revogada e encerrada.
            </p>

            <p>
                <strong>Registro de Conta</strong>
            </p>

            <p>
                Alguns serviços exigem que você crie uma conta. Sem fazer login,
                você pode não ter acesso a determinados recursos ou partes do
                serviço. Ao criar uma conta, você deve fornecer informações
                precisas e completas e atualizá-las prontamente. Mantenha seu
                nome de usuário e senha confidenciais e não use a mesma senha
                para outros sites ou serviços. Você deve remover e excluir o
                serviço do seu dispositivo antes de transferi-lo. Se você
                detectar ou suspeitar de qualquer acesso ou uso não autorizado
                de sua conta, notifique-nos imediatamente.
            </p>

            <p>
                Você declara que não está proibido de receber os serviços de
                acordo com as leis aplicáveis. Você também declara que tem idade
                legal em seu país ou está usando os serviços sob a aprovação e
                supervisão de um dos pais ou responsável legal, que revisou e
                concordou com estes Termos. Usuários menores de 13 anos não têm
                permissão para usar nossos serviços, e não coletamos
                conscientemente informações pessoais de tais indivíduos. Se uma
                conta pertencente a um usuário menor de 13 anos for
                descoberta,&nbsp;
            </p>

            <p>
                ela poderá ser excluída, e o acesso por IP poderá ser bloqueado.
                Quaisquer ativos virtuais ou itens de jogo não serão
                reembolsados, e presentes ou transações feitas para outros serão
                removidos.Para usuários acima de 13 anos, mas menores de idade,
                contas criadas e pagamentos feitos sem o consentimento dos pais
                poderão ser excluídos sem aviso prévio, e o bloqueio de IP
                poderá ser imposto para evitar recorrência. Nesses casos, não
                haverá reembolso de ativos virtuais, e presentes ou transações
                serão removidos.
            </p>

            <p>
                Apesar de qualquer disposição em contrário, você reconhece e
                concorda que não possui direitos de propriedade ou propriedade
                em sua conta e que todos os direitos da conta são
                permanentemente de propriedade e pertencem à NETDOOR. Não
                reconhecemos ou permitimos transferências de contas entre
                jogadores. Você não pode comprar, vender, presentear ou trocar
                qualquer conta, nem oferecer fazê-lo. Qualquer tentativa será
                nula e poderá resultar na rescisão e perda da conta. Qualquer
                conta inativa por mais de um ano poderá ser expirada e excluída.
            </p>

            <p>
                <strong>Atualizações</strong>
                <strong></strong>A NETDOOR pode fornecer atualizações para os
                jogos oferecidos através do PLYOSGAMES.COM e sites associados a
                seu exclusivo critério. Você reconhece e concorda que a NETDOOR
                pode fornecer atualizações automáticas remotamente para o seu
                dispositivo, incluindo acessar o dispositivo conforme
                necessário. Todas as atualizações fornecidas pela NETDOOR fazem
                parte do serviço e estão sujeitas a estes Termos.
            </p>

            <p>
                <strong>Consentimento para Monitoramento</strong>
                <strong></strong>O software pode transmitir informações,
                incluindo capacidade de hardware, detalhes de patches e
                modificações, e quaisquer programas de terceiros não autorizados
                que estejam rodando com o software, de volta ao licenciador.
                Programas de terceiros não autorizados são definidos pelo
                licenciador como software que, a seu exclusivo critério, permite
                trapaça, modifica ou hackeia a interface ou o ambiente do jogo
                de maneira não aprovada ou coleta dados do software. Se forem
                detectados programas não autorizados, o software pode enviar
                informações, como ID do usuário e detalhes da conta, de volta ao
                licenciador ou permitir que o licenciador exerça quaisquer
                direitos sob este acordo sem aviso prévio.
            </p>

            <p>
                <strong>Transferência Transfronteiriça</strong>
                <strong></strong>Ao aceitar estes Termos, você entende e
                concorda que, para cumprir estes Termos e fornecer os serviços,
                as informações coletadas em seu país podem ser transferidas para
                outros países, que podem não oferecer o mesmo nível de proteção
                que seu país de origem.
            </p>

            <p>
                <strong>Conteúdo Postado pelo Usuário</strong>
            </p>

            <p>
                Você é o único responsável por todas as comunicações, imagens,
                vídeos, sons, conteúdo ou conteúdo de banco de dados que você
                fizer upload ou transmitir por meio dos Serviços, incluindo, mas
                não se limitando a, texto, transmissões de voz ou gravações,
                clipes/capturas de tela de jogabilidade (“Conteúdo do Usuário”).
            </p>

            <p>
                Você declara e garante que o Conteúdo do Usuário que você postar
                ou transmitir não infringe os direitos autorais, marcas
                registradas ou outros direitos de propriedade intelectual de
                terceiros. Você também confirma que possui todas as licenças,
                direitos, consentimentos e permissões necessárias para postar o
                Conteúdo do Usuário no Serviço e que seu conteúdo não viola
                nenhuma lei, termo ou direitos de privacidade ou publicidade de
                terceiros. Você concorda em não promover sorteios não
                autorizados, loterias ou jogos de azar de qualquer tipo, nem
                interromper o acesso de outros usuários a informações
                relacionadas ao Serviço.
            </p>

            <p>
                Você não promoverá ou incentivará conteúdo ilegal ou
                comportamento socialmente irresponsável, como consumo de álcool
                por menores ou dirigir sob a influência de álcool, e não
                fornecerá instruções para a criação de itens perigosos, nem
                incentivará a violência ou atividades ilegais, incluindo
                terrorismo.
            </p>

            <p>
                Você concorda que a NETDOOR pode, a seu exclusivo critério,
                moderar, monitorar, revisar e registrar todo o Conteúdo do
                Usuário que você postar, transmitir ou fornecer (incluindo
                comunicações verbais ou escritas) e removê-lo sem aviso prévio
                por qualquer motivo.
            </p>

            <p>
                Ao aceitar estes termos, você concede à NETDOOR uma licença
                mundial, gratuita, perpétua, irrevogável, totalmente
                transferível, sublicenciável, não exclusiva para usar seu
                Conteúdo do Usuário em todos os meios e formatos para qualquer
                finalidade (incluindo fins comerciais, publicitários ou
                promocionais). Esta licença inclui os direitos de reproduzir,
                modificar, executar, exibir e distribuir seu Conteúdo do Usuário
                sem aviso adicional ou compensação.
            </p>

            <p>
                Você também renuncia a quaisquer direitos morais de atribuição,
                integridade ou autoria para o uso de seu Conteúdo do Usuário
                pela NETDOOR e outros jogadores em conexão com o Serviço. Esses
                direitos de licença e a renúncia de direitos morais sobrevivem à
                rescisão ou expiração destes Termos.
            </p>

            <p>
                <strong>Propriedade Intelectual</strong>
            </p>

            <p>
                Os Serviços (incluindo todas as atualizações) são protegidos por
                direitos autorais e outras leis de propriedade intelectual nos
                Estados Unidos, na União Europeia e em outros países. NETDOOR,
                PLYOSGAMES.COM, os jogos oferecidos e os logotipos e nomes
                relacionados são marcas registradas e/ou marcas de serviço da
                empresa. Outras marcas registradas, marcas de serviço, nomes e
                logotipos usados nos Serviços ou por meio deles são propriedade
                de seus respectivos proprietários.
            </p>

            <p>
                Nenhum direito ou licença é concedido para essas marcas
                registradas, marcas de serviço ou logotipos sem o consentimento
                prévio por escrito da empresa. A NETDOOR mantém todos os
                direitos, propriedades e interesses nos Serviços e em seus
                componentes, incluindo todos os direitos de propriedade
                intelectual. Alguns conteúdos fornecidos por meio dos Serviços
                podem incluir marcas d’água ou ser controlados por outras
                tecnologias de gerenciamento de direitos digitais, restringindo
                a forma como os Serviços são acessados e usados.
            </p>

            <p>
                Os Serviços podem acessar e monitorar seu dispositivo (incluindo
                discos rígidos, dispositivos de armazenamento, CPUs, RAM, placas
                de vídeo e hardware, software e aplicativos periféricos) para
                detectar software de terceiros não autorizado (“Software de
                Terceiros Não Autorizado”) proibido sob estes Termos.
            </p>

            <p>
                Se software não autorizado for detectado, a NETDOOR pode coletar
                informações adicionais, como seu nome de conta, detalhes sobre o
                software não autorizado e carimbos de data/hora, conforme
                explicado na Política de Privacidade da NETDOOR. Essas
                informações podem ser usadas para fazer cumprir estes Termos de
                acordo com a política de privacidade publicada em plyosgames.com
                e sites associados.
            </p>

            <p>
                A NETDOOR sempre está feliz em ouvir seus jogadores e fãs e
                acolhe feedback sobre nossos serviços. Todas as ideias,
                sugestões, propostas, feedback ou outras submissões
                (coletivamente referidos como “Feedback”) relacionadas aos
                nossos serviços ou ideias para novos conteúdos, recursos,
                produtos ou questões semelhantes, sejam submetidos publicamente
                ou em particular, não são tratados como confidenciais ou
                proprietários.
            </p>

            <p>
                Ao fornecer Feedback à NETDOOR, você renuncia a todos os
                direitos ao Feedback e permite que a NETDOOR ou outros usem,
                compartilhem e explorem comercialmente para qualquer propósito
                sem aviso ou compensação. A NETDOOR não tem obrigação de
                devolver ou revisar regularmente o Feedback e não assume
                responsabilidade em relação a ele.
            </p>

            <p>
                <strong>Moeda Virtual e Itens Virtuais</strong>
            </p>

            <p>
                Durante o uso dos Serviços, você poderá ter a oportunidade de
                visitar lojas online e no jogo para adquirir e usar a moeda
                virtual (VC) da NETDOOR e itens digitais no jogo (incluindo
                acesso antecipado a jogos em desenvolvimento). A NETDOOR pode
                fornecer pontos em relação ao seu uso dos Serviços.
            </p>

            <p>
                A moeda virtual e os pontos não têm valor “real”, mas podem ser
                trocados por itens no jogo. Uma vez que os itens são comprados
                ou presenteados a outros, eles e qualquer moeda virtual restante
                (VC) são considerados usados e não reembolsáveis.
            </p>

            <p>
                Os itens do jogo comprados nas lojas são licenciados para seu
                uso de acordo com estes Termos. Você não é proprietário dos
                itens obtidos com moeda virtual, independentemente do
                pagamento.Todos os preços, cotações e descrições apresentadas ou
                mencionadas em nossos Serviços não constituem ofertas e podem
                ser retiradas ou alteradas pela NETDOOR antes de aceitar
                explicitamente seu pedido. Os preços listados não incluem
                impostos.
            </p>

            <p>
                Você concorda em pagar todas as taxas, encargos e impostos
                aplicáveis incorridos pelo uso de sua conta ou dispositivo ao
                preço vigente no momento em que as taxas foram incorridas.A
                NETDOOR pode alterar os preços dos Serviços a qualquer momento,
                de acordo com as leis aplicáveis. A NETDOOR se reserva o direito
                de notificá-lo sobre erros nas descrições ou preços dos produtos
                antes de despachar o produto. Se você optar por prosseguir, o
                produto ou serviço será fornecido de acordo com a descrição ou
                preço corrigido.
            </p>

            <p>
                Você pode adquirir moeda virtual por meio de vários métodos de
                pagamento. Ao usar fornecedores de pagamento e faturamento de
                terceiros, podem ser aplicados termos, condições e taxas
                adicionais.Ao fornecer informações de pagamento aos sites
                operados pela NETDOOR ou processadores de pagamento, você
                declara que é o usuário autorizado do método de pagamento,
                cartão ou conta e permite que a NETDOOR cobre ou processe
                pagamentos por meio de seu cartão de crédito ou provedor
                terceirizado escolhido, incluindo o compartilhamento de
                informações pessoais para fins de verificação de pagamento.
            </p>

            <p>
                Você concorda em não contornar restrições geográficas ao
                conteúdo do jogo, fazer pedidos a preços não aplicáveis à sua
                região ou usar proxies de IP ou outros meios para disfarçar sua
                localização.Os titulares de contas são responsáveis por todos os
                encargos, incluindo impostos, associados a pedidos ou compras
                feitas por qualquer pessoa que use sua conta, incluindo
                familiares ou amigos. A NETDOOR se reserva o direito de cobrar
                quaisquer taxas, encargos ou custos incorridos antes do
                cancelamento da conta. Contas inadimplentes ou em atraso devem
                ser liquidadas antes de um novo registro com a NETDOOR.
            </p>

            <p>
                Você é responsável por pagar todos os impostos federais,
                estaduais e locais relacionados ao recebimento ou uso de itens
                virtuais comprados da NETDOOR.
            </p>

            <p>
                Pode haver um valor mínimo para compras de moeda virtual, e
                certos valores máximos podem ser aplicados, dependendo do método
                de transação. A NETDOOR se reserva o direito de alterar esses
                limites a qualquer momento, em conformidade com as leis
                aplicáveis, sem aviso prévio.
            </p>

            <p>
                Você entende e concorda que a NETDOOR não oferece reembolsos
                para itens digitais no jogo ou moeda virtual não utilizada
                (VC).Pagamentos feitos em nome de outra pessoa (incluindo sem
                consentimento dos pais para menores) são considerados
                fraudulentos, e as contas podem ser excluídas e o acesso por IP
                bloqueado. A NETDOOR toma cuidado em incluir avisos sobre
                consentimento dos pais para menores, mas a responsabilidade por
                transações não autorizadas recai sobre o menor e seu
                responsável, não sobre a NETDOOR.
            </p>

            <p>
                Se sua conta for permanentemente banida, todas as licenças de
                conteúdo e moeda virtual restante serão perdidas. Além disso,
                presentes ou transações feitas para outros de uma conta banida
                podem resultar na exclusão desses itens. A NETDOOR não é
                obrigada a compensar por moeda virtual perdida, pontos, itens ou
                experiência resultante de uma violação destes Termos.
            </p>

            <p>
                Os itens podem expirar. Cada item adquirido com moeda virtual ou
                pontos permanece válido até a data de expiração do item,
                encerramento da conta ou expiração destes Termos ou do Serviço,
                o que ocorrer primeiro. Os preços e a disponibilidade dos itens
                podem mudar sem aviso prévio, em conformidade com as leis
                aplicáveis.
            </p>

            <p>
                Se quaisquer encargos que você autorizou por meio de um serviço
                de pagamento de terceiros não forem processados, pagos ou
                reembolsados, a NETDOOR poderá suspender ou encerrar sua conta.
                Nesse caso, você deve transferir rapidamente o saldo pendente
                usando outro método de pagamento. A NETDOOR não é responsável
                por taxas de cartão de crédito ou banco associadas às suas
                transações.
            </p>

            <p>
                A NETDOOR se reserva o direito de limitar a quantidade de itens
                em qualquer pedido ou recusar o fornecimento de itens sem aviso
                prévio. Você pode ser solicitado a verificar as informações da
                transação antes que a NETDOOR a aceite.
            </p>

            <p>
                <strong>Código de Conduta</strong>
            </p>

            <p>
                Você não pode usar os Serviços de qualquer maneira que seja
                ilegal, que danifique ou sobrecarregue os Serviços ou que
                interfira no uso de outros, a critério exclusivo da NETDOOR. Sem
                limitar a generalidade do exposto, as seguintes ações proibidas
                se aplicam de acordo com as leis aplicáveis:
            </p>

            <ul>
                <li>
                    Usar hacks, cracks, bots ou software de terceiros que
                    modifiquem o código ou a experiência do usuário do Serviço
                    em dispositivos locais ou servidores, ou usar aplicativos,
                    softwares ou tecnologias para realizar tarefas no jogo sem a
                    aprovação explícita da NETDOOR, incluindo a habilitação de
                    trapaças ou “power leveling”.
                </li>

                <li>
                    Fazer engenharia reversa, descompilar ou tentar derivar o
                    código-fonte, algoritmos ou técnicas do Serviço.
                </li>

                <li>
                    Fazer-se passar por outros ou falsamente representar sua
                    afiliação, identidade ou a origem dos materiais
                    transmitidos, ou deturpar suas declarações ou ações como
                    endossadas pela NETDOOR.
                </li>

                <li>
                    Usar robôs, spiders ou outros processos automatizados para
                    acessar ou burlar a estrutura ou o conteúdo do Serviço.
                </li>

                <li>
                    Remover ou alterar avisos, símbolos ou etiquetas de
                    propriedade (incluindo marcas d’água ou gerenciamento de
                    direitos digitais) incorporados no Serviço.
                </li>

                <li>
                    Tomar ações que imponham uma carga indevida ou
                    desproporcional em nossa rede ou infraestrutura.
                </li>

                <li>
                    Hospedar ou fornecer serviços de matchmaking não autorizados
                    ou criar conexões não autorizadas com o Serviço.
                </li>

                <li>
                    Interceptar, emular ou redirecionar protocolos de
                    comunicação ou usar qualquer programa utilitário para
                    interceptar, coletar ou minerar dados gerados pelo Serviço.
                </li>

                <li>
                    Distribuir vírus, malware ou outros softwares prejudiciais
                    destinados a interromper ou danificar os sistemas ou redes
                    da NETDOOR.
                </li>

                <li>
                    Usar macros ou automação para controlar o jogo sem estar
                    presente.
                </li>

                <li>
                    Criar mais de duas contas em 24 horas ou mais de cinco
                    contas em 30 dias, ou exceder o acesso autorizado a qualquer
                    parte do Serviço.
                </li>

                <li>
                    Distribuir materiais não autorizados ou promover produtos ou
                    serviços sem a permissão da NETDOOR (por exemplo, spam,
                    esquemas de pirâmide ou solicitações).
                </li>

                <li>
                    Engajar-se em qualquer comportamento considerado
                    prejudicial, assediador, difamatório, obsceno, odioso ou
                    violento, incluindo perseguição ou conteúdo sexualmente
                    explícito.
                </li>

                <li>
                    Vender ou promover hacks, servidores privados ou “gold
                    farming”.
                </li>

                <li>
                    Explorar bugs do jogo ou questões não documentadas para
                    criar, usar ou negociar itens no jogo.
                </li>

                <li>
                    Publicar ou compartilhar informações pessoais de outros
                    usuários ou dados confidenciais da empresa sem
                    consentimento.
                </li>

                <li>
                    Envolver-se em quaisquer ações que exponham a NETDOOR, seus
                    usuários ou terceiros a responsabilidade legal ou danos.
                </li>
            </ul>

            <p>
                Violar a segurança do sistema ou da rede ou tentar interferir na
                operação do Serviço pode resultar em responsabilidade civil ou
                criminal. A NETDOOR se reserva o direito de investigar violações
                e cooperar com a aplicação da lei para processar.
            </p>

            <p>
                A NETDOOR pode suspender, modificar ou encerrar o acesso ao
                Serviço a qualquer momento, sem aviso prévio, por qualquer
                motivo. Se sua conta for suspensa durante um torneio, a NETDOOR
                não se responsabiliza por qualquer perda de prêmios ou
                reconhecimento em potencial.
            </p>

            <p>
                <strong>
                    Serviços, Conteúdos, Dispositivos e Redes de Terceiros
                </strong>
            </p>

            <p>
                Os Serviços podem estar disponíveis por meio de serviços de
                terceiros, como Apple iTunes ou Google Play, ou por meio de
                dispositivos de terceiros, como consoles de jogos. Os Serviços
                também podem incluir ou ter links para conteúdos de terceiros
                (incluindo conteúdos postados por usuários em fóruns). A NETDOOR
                não controla, endossa, patrocina ou assume responsabilidade por
                esses serviços, conteúdos ou dispositivos de terceiros. Os
                serviços de terceiros podem exigir software adicional, registro
                de conta ou aceitação de termos.
            </p>

            <p>
                O uso de serviços, conteúdos ou dispositivos de terceiros é por
                sua conta e risco e está sujeito aos termos de terceiros. A
                NETDOOR não é responsável pelo uso ou dependência de serviços,
                conteúdos ou dispositivos de terceiros.
            </p>

            <p>
                Seu dispositivo pode se conectar a ou usar redes de terceiros ao
                utilizar nossos Serviços, o que pode gerar taxas. Você é o único
                responsável por todos os custos e encargos relacionados ao
                acesso e uso dos Serviços, incluindo taxas de provedores de
                serviços de internet, encargos de comunicação, taxas de
                mensagens de texto, cobranças de banda larga excedente e custos
                de dispositivos ou equipamentos.
            </p>

            <p>
                <strong>
                    Isenção de Garantias; Limitação de Responsabilidade
                </strong>
            </p>

            <p>
                A NETDOOR, seus desenvolvedores e prestadores de serviços não
                fazem representações quanto à adequação, confiabilidade,
                disponibilidade, pontualidade, precisão ou desempenho das
                informações, software, produtos, serviços ou conteúdo fornecidos
                nos Serviços. O uso dos Serviços é por sua conta e risco. Os
                Serviços são fornecidos “como estão”, sem quaisquer garantias.
            </p>

            <p>
                A NETDOOR, seus desenvolvedores e prestadores de serviços
                renunciam a todas as garantias implícitas, incluindo garantias
                de comercialização, adequação a um propósito específico,
                titularidade e não violação. Algumas jurisdições não permitem a
                exclusão de garantias implícitas, portanto, essas exclusões
                podem não se aplicar a você.
            </p>

            <p>
                Você concorda que, sob nenhuma circunstância, a NETDOOR, seus
                agentes, diretores, parceiros, acionistas, empreiteiros,
                funcionários, licenciados, licenciadores, anunciantes ou agentes
                serão responsáveis por quaisquer danos diretos ou indiretos,
                especiais, incidentais, consequenciais ou punitivos, incluindo
                perda de lucros ou outras perdas relacionadas ao seu uso, uso
                indevido, confiança, revisão, manipulação ou qualquer outra
                forma de interação com os Serviços ou dados coletados dos
                mesmos.Você também concorda que:
            </p>

            <p>
                (a) O uso do site é por sua conta e risco. O site é fornecido
                “como está” e “conforme disponível”. A NETDOOR e seus afiliados,
                diretores, funcionários, agentes, parceiros e licenciadores
                expressamente renunciam a todas as garantias de qualquer tipo,
                sejam expressas ou implícitas, incluindo garantias implícitas de
                comercialização, adequação a um propósito específico e não
                violação.
            </p>

            <p>
                (b) A NETDOOR não garante que (i) o site atenderá às suas
                necessidades; (ii) o site será ininterrupto, pontual, seguro ou
                livre de erros; (iii) quaisquer produtos, serviços, informações
                ou outros materiais obtidos por meio do site atenderão às suas
                expectativas; ou (iv) quaisquer erros de software serão
                corrigidos.
            </p>

            <p>
                (c) Qualquer material baixado ou obtido de outra forma por meio
                do uso do site é acessado por sua conta e risco, e você é o
                único responsável por quaisquer danos ao seu sistema de
                computador ou perda de dados resultantes do download de tal
                material.
            </p>

            <p>
                (d) Nenhum conselho ou informação, seja oral ou escrito, obtido
                por você da NETDOOR ou por meio do site criará qualquer garantia
                que não esteja expressamente declarada nos termos.
            </p>

            <p>
                (e) Uma pequena porcentagem de usuários pode experimentar
                convulsões ao ser exposta a certos padrões de luz ou fundos em
                telas de computador ou ao usar o site. Mesmo pessoas que não têm
                histórico de convulsões ou epilepsia podem ter uma condição não
                diagnosticada que pode desencadear essas convulsões. Se você ou
                alguém da sua família tiver uma condição epiléptica, consulte
                seu médico antes de usar os Serviços. Interrompa imediatamente o
                uso dos Serviços e consulte um médico se sentir tontura, visão
                alterada, contração ocular ou muscular, perda de consciência,
                desorientação ou movimentos involuntários.
            </p>

            <p>
                Isso se aplica mesmo que você tenha sido avisado sobre a
                possibilidade de tais danos. Algumas jurisdições não permitem a
                exclusão ou limitação de responsabilidade por danos
                consequenciais ou incidentais, portanto, essas limitações podem
                não se aplicar a você. Se você estiver insatisfeito com qualquer
                parte dos Serviços ou com qualquer um desses termos, seu único e
                exclusivo recurso é descontinuar o uso dos Serviços.
            </p>

            <p>
                A pedido da NETDOOR, você concorda em defender, indenizar e
                isentar de responsabilidade (a) NETDOOR INC., (b) seus
                acionistas, parceiros, afiliados, diretores, funcionários,
                subsidiárias, agentes ou fornecedores, (c) seus licenciados,
                distribuidores, provedores de conteúdo e (d) outros membros dos
                Serviços contra quaisquer danos, responsabilidades,
                reivindicações e despesas (incluindo honorários advocatícios e
                custos) decorrentes de ou relacionados ao uso indevido dos
                Serviços ou à violação deste contrato, direta ou indiretamente.
            </p>

            <p>
                <strong>Modificação do Acordo</strong>
            </p>

            <p>
                A NETDOOR reserva-se o direito de modificar, alterar, adicionar
                ou excluir quaisquer termos deste acordo a seu exclusivo
                critério, sem aviso prévio. Os acordos atualizados podem ser
                visualizados em plyosgames.com e sites associados, e entrarão em
                vigor após a publicação. O uso continuado do software após a
                publicação do acordo atualizado implica a aceitação de todas as
                alterações.Se você não concordar com alterações futuras, poderá
                rescindir o acordo retirando sua associação. No entanto,
                quaisquer violações ocorridas durante o período de associação
                continuam sujeitas a ações legais conforme o acordo vigente na
                época.
            </p>

            <p>
                <strong>Jurisdição</strong>
            </p>

            <p>
                Em caso de disputa, o tribunal competente é o tribunal
                localizado na Coreia do Sul, onde o desenvolvedor está baseado.
            </p>

            <p>
                <strong>Disposições Adicionais</strong>
            </p>

            <p>
                Ao concordar com as políticas da NETDOOR e este acordo fornecido
                por meio de plyosgames.com e seus subdomínios, você confirma que
                cumprirá todos os termos.Alguns serviços podem ser regidos por
                termos, condições, regras ou diretrizes adicionais (“Termos
                Adicionais”), que você deve concordar antes de utilizar esses
                serviços. Se houver um conflito entre os termos deste acordo e
                quaisquer Termos Adicionais, os Termos Adicionais prevalecerão
                para os serviços relevantes.
            </p>

            <p>
                Para consultas, entre em contato:
                <a href='https://plyosgames.freshdesk.com/support/tickets/new'>
                    {' '}
                    https://plyosgames.freshdesk.com/support/tickets/new
                </a>
                .
            </p>
        </div>
    );
};

export default TermsOfService;
